import { combineReducers } from 'redux';
import auth from './auth';
import search from './search';
import page from './page';
import app from './app';

export default combineReducers({
    auth, search, page, app
});